import { Parse } from 'parse'

export function enableAuthenticatedParseFileUploads() {
  const originalFileController = Parse.CoreManager.getFileController()

  Parse.CoreManager.setFileController({
    saveBase64: originalFileController.saveBase64.bind(originalFileController),
    saveFile: function saveFileWithSessionToken(name, source) {
      if (source.format !== 'file') {
        throw new Error('saveFile can only be used with File-type sources.')
      }

      const headers = {
        'X-Parse-Application-ID': Parse.CoreManager.get('APPLICATION_ID'),
        'X-Parse-JavaScript-Key': Parse.CoreManager.get('JAVASCRIPT_KEY'),
        'Content-Type': source.type || (source.file ? source.file.type : null)
      }

      const currentUser = Parse.User.current()
      if (currentUser) {
        headers['X-Parse-Session-Token'] = currentUser.getSessionToken()
      }

      let url = Parse.CoreManager.get('SERVER_URL')
      if (url[url.length - 1] !== '/') {
        url += '/'
      }
      url += 'files/' + name

      return Parse.CoreManager.getRESTController().ajax('POST', url, source.file, headers)
    }
  })
}
